import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=2cda739e"
import script from "./PaymentForm.vue?vue&type=script&lang=ts"
export * from "./PaymentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports